import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Platform, MenuController, App} from 'ionic-angular';
import {ServiceProvider} from '../../providers/service/service';
import {Storage} from '@ionic/storage';
import {AlertController, Nav, ToastController, LoadingController, ModalController} from 'ionic-angular';
import {DomSanitizer} from '@angular/platform-browser';
import {Contacts, Contact, ContactField, ContactName} from '@ionic-native/contacts';
import {SocialSharing} from '@ionic-native/social-sharing';
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {FileTransfer, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from '@ionic-native/file';
import {InAppBrowser} from "@ionic-native/in-app-browser";


@Component({
    selector: 'page-daily-logs',
    templateUrl: 'daily-logs.html',
})
export class DailyLogsPage {

    FilterOption = 'Date';
    Date: any;
    DisplayDate = "";
    monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    FUserId: any;
    datanotfound: any;
    DailyLogsData = [];
    DailyLogsData1 = [];
    IsSearch = 0;

    School = 'All';
    SchoolData = {};
    Status = 'All';
    StatusData = {};

    UserSearchData: any;
    SearchUser: any;
    FWebEnquiryIdSearch:any;
    AnyDataSearch:any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public service: ServiceProvider,
                public platform: Platform,
                menuCtrl: MenuController,
                public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                public alertCtrl: AlertController,
                private modalCtrl: ModalController,
                public storage: Storage,
                private sanitizer: DomSanitizer,
                public _app: App,
                private contacts: Contacts,
                private socialSharing: SocialSharing,
                private androidPermissions: AndroidPermissions,
                private file: File,
                private transfer: FileTransfer,
                public iab: InAppBrowser) {
        this.platform.ready().then(() => {

            this.Date = new Date();
            this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
            this.Date = this.Date.toISOString();


            this.SchoolData = {
                "All": 0,
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.StatusData = {
                "All": 0,
                "Data": 1,
                "Apt": 2,
                "Enq": 3,
                "Fb": 4,
                "Adm": 5,
                "Archive": 6,
                "Edit": 7,
                "UnArchive":8
            }


            Promise.all([this.storage.get('LoginData')]).then(values => {
                this.FUserId = values[0]['FUserId'];
                console.log(this.FUserId);
                this.loadvalues(this.FUserId, this.DisplayDate, this.SchoolData[this.School], this.StatusData[this.Status]);
            });
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad DailyLogsPage');
    }

    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.active_Staus_tab(this.Status);
        this.FWebEnquiryIdSearch=null;
        this.AnyDataSearch=null;
    }

    active_Staus_tab(tab) {
        console.log(tab);
        this.Status = tab;
        this.FWebEnquiryIdSearch=null;
        this.AnyDataSearch=null;
        this.loadvalues(this.FUserId, this.DisplayDate, this.SchoolData[this.School], this.StatusData[this.Status]);
    }

    add_filter(f) {
        this.FWebEnquiryIdSearch=null;
        this.AnyDataSearch=null;
        console.log(f);
        if (f == 'All') {
            this.FilterOption = 'All';
            this.DisplayDate = "";
            this.loadvalues(this.FUserId, this.DisplayDate, this.SchoolData[this.School], this.StatusData[this.Status]);
        } else {
            this.FilterOption = 'Date';
            var Date1 = new Date(this.Date);
            console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
            this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
            console.log("DisplayDate ", this.DisplayDate);
            this.loadvalues(this.FUserId, this.DisplayDate, this.SchoolData[this.School], this.StatusData[this.Status]);
            console.log('Date call');
        }

    }


    Prev(date) {
        this.Date = new Date(date);
        this.Date.setDate(this.Date.getDate(date) - 1);
        this.Date = this.Date.toISOString();
        //in this case ion-datetime will call ionChange event
    }

    Next(date) {
        this.Date = new Date(date);
        this.Date.setDate(this.Date.getDate(date) + 1);
        this.Date = this.Date.toISOString();
        //in this case ion-datetime will call ionChange event
    }

    loadvalues(FUserId, DisplayDate, School, Status) {
        this.datanotfound = null;
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });

        loading.present();
        setTimeout(() => {
            loading.dismiss();
            loading = undefined;
        }, 3000);
        this.DailyLogsData = [];
        this.UserSearchData = [];
        this.DailyLogsData1 = [];
        this.SearchUser = null;


        this.service.httpcall('app_web_service/get_daily_logs?FUserId=' + FUserId + '&Date=' + DisplayDate + '&FSchoolId=' + School + '&StatusId=' + Status).subscribe(data => {
            console.log(data);

            if (loading)
                loading.dismiss();
            loading = undefined;

            if (data['response'] == "success") {
                this.DailyLogsData1=data['data'];
                this.DailyLogsData = this.DailyLogsData1;

                this.UserSearchData = data['UserData'];

            } else {
                this.datanotfound = data['error_description'];
            }
        })
    }

    searchData(ev: any, type) {
        // Reset items back to all of the items
        this.DailyLogsData = this.DailyLogsData1;
        // set val to the value of the searchbar

        let val = null;
        // if (type == 'CreatedByNameSearch') {
            val = ev;
        // } else {
        //     val = ev.target.value;
        // }


        console.log("Search -> ", val);

        console.log("DailyLogsData -> ",this.DailyLogsData);
        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.DailyLogsData = this.DailyLogsData.filter((item) => {
                if (type == 'FWebEnquiryIdSearch') {
                    return (item.FWebEnquiryId.toLowerCase().indexOf(val.toLowerCase()) > -1);
                } else if (type == 'CreatedByNameSearch') {
                    if(item.CreateByName!=null){
                        return (item.CreateByName.toLowerCase().indexOf(val.toLowerCase()) > -1);
                    }
                } else {
                    return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
                }
            })
        }

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);
        this.loadvalues(this.FUserId, this.DisplayDate, this.SchoolData[this.School], this.StatusData[this.Status]);
        setTimeout(() => {
            console.log('Async operation has ended');
            refresher.complete();
        }, 2000);
    }

}



// WEBPACK FOOTER //
// ./src/pages/daily-logs/daily-logs.ts